const ATOMIC_QUEUE_CONTRACT_ADDRESS = "0x228c44bb4885c6633f4b6c83f14622f37d5112e5";
const DEFAULT_WITHDRAW_SLIPPAGE = 20;
const DEFAULT_DEPOSIT_SLIPPAGE = 50;
const DEFAULT_DEADLINE = 3;
const NATIVE_TOKEN_FOR_BRIDGE_FEE = "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee";
const CHAINLINK_ADDRESS = "0x5f4eC3Df9cbd43714FE2740f5E3616155c5b8419";
const DEFAULT_APPROVAL_AMOUNT = BigInt(2) ** BigInt(256) - BigInt(1);
const NUCLEUS_BASE_URL = "https://backend.nucleusearn.io/v1/protocol";
export {
  ATOMIC_QUEUE_CONTRACT_ADDRESS,
  CHAINLINK_ADDRESS,
  DEFAULT_APPROVAL_AMOUNT,
  DEFAULT_DEADLINE,
  DEFAULT_DEPOSIT_SLIPPAGE,
  DEFAULT_WITHDRAW_SLIPPAGE,
  NATIVE_TOKEN_FOR_BRIDGE_FEE,
  NUCLEUS_BASE_URL
};
//# sourceMappingURL=index.mjs.map